import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import * as moment from 'moment';

import { Store, ModelService } from 'src/app/common';
import { FlightModel } from '../../models/flight.model';

@Component({
  selector: "createFlightModal",
  templateUrl: "./createFlight.html"
})
export class CreateFlightModal {

  public edit: boolean = false;

  public isLoading: boolean = false;

  public form: FormGroup;

  public store: Store<FlightModel>;

  public model: FlightModel;

  public projectId: number;

  constructor(private modal: NzModalRef,
              private modelService: ModelService,
              private message: NzMessageService,
              private ts: TranslateService,
              private fb: FormBuilder,) {

    this.store = this.modelService.getStore('FlightModel');
    this.createForm();

    setTimeout(() => {
      if(this.model !== undefined){
        this.edit = true;
        this.fillForm();
      }else{
        this.model = new FlightModel({
          project: {id: this.projectId}
        });
      }
    }, 0);
  }

  private createForm(): void {
		this.form = this.fb.group({
      name: [null, Validators.required],
      date: [moment().toDate(), Validators.required]
		});
  }

  private fillForm(): void {
		this.model.populateFormWihtModel(this.form);
  }

  private destroyModal(success: boolean): void {
    this.modal.destroy({data: success});
  }

  public onCancelClick(): void {
    this.destroyModal(false);
  }

  public onSubmitClick(): void {
    this.form.controls.name.setValue(this.form.value.name.trim());

    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (!this.form.valid) return;

    this.edit ? this.update() : this.create();
  }

  private create(): void {
    this.isLoading = true;

    this.model.populateModelWithForm(this.form);
    this.store.create(this.model).subscribe((res) => {
      this.isLoading = false;
      if(res){
        this.message.success(this.ts.instant('drone.createFlightModal.create.succesMsg'));
        this.destroyModal(true);
      }else{
        this.message.error(this.ts.instant('drone.createFlightModal.create.errorMsg'));
      }
    });
  }

  private update(): void {
    this.isLoading = true;

    this.model.populateModelWithForm(this.form);
    this.store.update(this.model).subscribe((res) => {
      this.isLoading = false;
      if(res){
        this.message.success(this.ts.instant('drone.createFlightModal.update.succesMsg'));
        this.destroyModal(true);
      }else{
        this.message.error(this.ts.instant('drone.createFlightModal.update.errorMsg'));
      }
    });
  }
}
